import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedCustomCategories: [],
    selectedCustomConfigNames: [],
    selectedCustomConfigCategories: {}, // { [configName]: selectedCategory }
};

const campaignMappingsSlice = createSlice({
    name: "campaignMappingsUi",
    initialState,
    reducers: {
        setSelectedCustomCategories: (state, action) => {
            state.selectedCustomCategories = Array.isArray(action.payload) ? action.payload : [];
        },
        setSelectedCustomConfigNames: (state, action) => {
            state.selectedCustomConfigNames = Array.isArray(action.payload) ? action.payload : [];
        },
        setSelectedCustomConfigCategory: (state, action) => {
            const { configName, value } = action.payload || {};
            if (!configName) return;
            state.selectedCustomConfigCategories = {
                ...state.selectedCustomConfigCategories,
                [configName]: value
            };
        },
    },
});

export const {
    setSelectedCustomCategories,
    setSelectedCustomConfigNames,
    setSelectedCustomConfigCategory,
} = campaignMappingsSlice.actions;

export default campaignMappingsSlice.reducer;


